<template>
  <section class="bg-lifeboost-orange-100 ">
    <div class="max-w-screen-xl px-4 py-8 mx-auto text-center lg:py-8 lg:px-6">
      <div class="max-w-screen-sm mx-auto">
        <nuxt-img :src="mainRatingSrc" alt="rating" class="mx-auto" width="222" height="90" format="webp"
          loading="lazy"></nuxt-img>
      </div>
      <ClientOnly>
        <Swiper autoHeight :class="'relative overflow-hidden '"
          :autoplay="{ delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true }" :modules="[SwiperNavigation]"
          :slidesPerView="1" :spaceBetween="50" :loop="true" :navigation="{
            nextEl: '.swiper-button-next-latte',
            prevEl: '.swiper-button-prev-latte'
          }" :breakpoints="{
              768: { slidesPerView: 1 }
            }">
          <SwiperSlide v-for="(testimonial, index) in testimonials" :key="index">
            <div class="w-full max-w-screen-md mx-auto" data-carousel-item>

              <div>
                <p class="font-medium text-white h1" v-html="testimonial.title"></p>
                <p class="mt-2 font-light text-white textp" v-html="testimonial.text"></p>
              </div>
              <div :class="testimonial.imgSrc ? 'flex-col gap-y-2' : ''" class="flex items-center justify-center px-2 py-2 mx-auto mt-6 space-x-3 bg-white max-w-fit">
                <div>
                  <div v-if="testimonial.imgSrc">
                    <nuxt-img :src="testimonial.imgSrc" :alt="testimonial.name" :class="testimonial.imgSrc ? 'w-48' :'w-32'" class="object-cover" width="128"
                    height="116" format="webp" loading="lazy"></nuxt-img>
                  </div>
                  <div v-else class="flex items-center justify-center w-8 h-8 bg-gray-300 rounded-full"
                    v-html="testimonial.initials"></div>
                </div>
                <div class="flex items-center divide-x-2 divide-gray-500 font-open-sans">
                  <div :class="testimonial.name ? 'pr-3' : 'pr-0'" class="font-medium text-gray-900 "
                    v-html="testimonial.name"></div>
                  <div class="pl-3 text-sm font-light text-gray-500 ">
                    <nuxt-img :src="testimonial.ratingSrc" alt="rating" class="sm-max:m-auto" width="100" height="16"
                      format="webp" loading="lazy"></nuxt-img>

                  </div>
                </div>
              </div>
            </div>
            <div class="flex items-center justify-center mt-4 gap-x-8">

            </div>
          </SwiperSlide>

          <div class="flex justify-center">
            <button type="button"
              class="flex items-center justify-center h-full cursor-pointer swiper-button-prev-latte group focus:outline-none">
              <span class="">
                <nuxt-img src="/assets/images/arrow-swiper.png" alt="rating" class="sm-max:m-auto" width="80"
                  height="16" format="webp" loading="lazy"></nuxt-img>
                <span class="hidden">Previous</span>
              </span>
            </button>
            <button type="button"
              class="flex items-center justify-center h-full cursor-pointer group focus:outline-none swiper-button-next-latte">
              <span class="rotate-180">
                <nuxt-img src="/assets/images/arrow-swiper.png" alt="rating" class="sm-max:m-auto" width="80"
                  height="16" format="webp" loading="lazy"></nuxt-img>
                <span class="hidden">Next</span>
              </span>
            </button>
          </div>
        </Swiper>


      </ClientOnly>

 

    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  mainRatingSrc: {
    type: String,
    default: '/assets/images/image4.png'
  },

  testimonials: {
    type: Array,
    default: () => [
      {
        title: 'Excellent coffee',
        text: "This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay!",
        initials: 'HT',
        name: 'Holly T. ',
        ratingSrc: '/assets/images/rating-yellow.png',
        imgSrc : '/assets/images/hollyt.jpg'
      },
      {
        title: 'Best Mushroom Coffee Ever!',
        text: "Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!",
        initials: 'T',
        name: 'Terry',
        ratingSrc: '/assets/images/rating-yellow.png',
      },
      {
        title: 'Love it',
        text: 'Nice and smooth great taste. I need this on auto delivery.',
        initials: 'BW',
        name: 'Beverly Watts',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "I love the smooth taste and it gives me extra energy and cognition!",
        initials: 'DB',
        name: 'Debra Bergfeld',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Cognition Mushroom ground coffee',
        text: "Super taste.  Mild and smooth. Like it really well.  I have yet to not like any coffee I have ordered",
        initials: 'JR',
        name: 'Jane Rupert',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "I THOROUGHLY ENJOY MY LIFEBOOST COFFEE. I usually purchase just the medium and light roast, but this time I decided to try the Coffee with Mushrooms. I love it! Great products that are non- irritating, less acid. 👍🏽",
        initials: 'DJ',
        name: 'Donna Jenkins',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Great tasting mushroom coffee',
        text: "I was not sure how this coffee was going to taste because I do not like mushrooms, but this is a very good tasting coffee. I am actually ordering another bag.",
        initials: 'SJ',
        name: 'Sandra JohnsonHarrell',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Love it!',
        text: "Can't tell the difference in the taste from my usual medium roast coffee!",
        initials: 'CN',
        name: 'Candace Nunez',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Mushrooms, really?',
        text: "I love mushrooms, but I could not detect a hint of mushrooms at all. Very good medium roast!  And a bonus by helping your brain.",
        initials: 'SM',
        name: 'Susan McFarland',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "Very smooth and great taste",
        initials: 'KS',
        name: 'Kenneth Shaw',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "Great tasting!!",
        initials: 'EB',
        name: 'Emily Bottoms',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Love it',
        text: "Love it, Great taste, no bitterness.",
        initials: 'NB',
        name: 'Nancy Barney',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Blew my Mind!',
        text: "Can't believe how much this really helps synergize with the coffee.  I make my coffee with coconut oil, butter, dash of honey and A2 creamer.  Adding the mushrooms (that you can barely taste by the way) has helped increased the effect of the coffee with no crash and constant energy all day long.  10/10 would reccomend.  Just ordered a 3 pack!  It's now officially a staple.",
        initials: 'T',
        name: 'Tom',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Great Stuff!',
        text: "I was a bit fearful that the mushroom-iness of the coffee would be discernible. It is not. It tastes like great Lifeboost coffee. But it does make me feel sharper.",
        initials: 'TP',
        name: 'Tammy Parker',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Our new favorite',
        text: "We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship.",
        initials: 'NS',
        name: 'Natasha Smith',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'One of the best!!!',
        text: "My morning joy has reached a new level of quality! Excellent!!!",
        initials: 'KT',
        name: 'Kleoniki Tsotropoulou',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "I purchased this new coffee for my husband. He said it is the best coffee and loves the benefits of the mushrooms.",
        initials: 'RP',
        name: 'Renee Patterson',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "I love this product!!!",
        initials: 'AG',
        name: 'Ariel Graf',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Love this version of coffee!',
        text: "Never even heard of it.  After trying it it’s become my second ( or third ) cup of coffee most days.  Different and Delicious!  The health benefits the shrooms add make it even cooler!  Bravo!",
        initials: 'SR',
        name: 'Steven W. Ross',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: '',
        text: "Smooth and tasty",
        initials: 'JH',
        name: 'Janice Hardy Hardy',
        ratingSrc: '/assets/images/rating-yellow.png'
      },
      {
        title: 'Cognition Mushroom coffee is the best!',
        text: "Best coffee option yet!   It is our family's favorite, both for flavor and the way it makes us feel.  Energetic yet calm, no jitters.",
        initials: 'P',
        name: 'Pam ',
        ratingSrc: '/assets/images/rating-yellow.png'
      }
    ]
  }
});

defineBuilderComponent({
  friendlyName: "Testimonial Swiper",
  canHaveChildren: true,
  inputs: [
    {
      name: 'testimonials',
      type: 'list',
      subFields: [
        {
          name: 'title',
          type: 'richText',
          required: true
        },
        {
          name: 'text',
          type: 'richText',
          required: true
        },
        {
          name: 'initials',
          type: 'text',
          required: true
        },
        {
          name: 'name',
          type: 'text',
          required: false
        },
        {
          name: 'date',
          type: 'text',
          required: false
        },
        {
          name: 'ratingSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png', 'webp'],
          required: true
        },
        {
          name: 'ratingSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png', 'webp'],
          required: true
        },
        {
          name: 'imgSrc',
          type: 'file',
          allowedFileTypes: ['jpeg', 'jpg', 'svg', 'png', 'webp'],
          required: false
        }
      ],
      defaultValue: [
        {
          title: 'Excellent coffee',
          text: "This coffee is smooth and delicious just like all the Lifeboost coffees. Great products from a great company. Yay!",
          initials: 'HT',
          name: 'Holly T. ',
          ratingSrc: '/assets/images/rating-yellow.png',
          imgSrc : '/assets/images/hollyt.jpg'
        },
        {
          title: 'Best Mushroom Coffee Ever!',
          text: "Just love the taste of this coffee! The mushrooms are not overwhelming and the coffee has a superior flavor. After trying other brands, this is by far my favorite!",
          initials: 'T',
          name: 'Terry',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Love it',
          text: 'Nice and smooth great taste. I need this on auto delivery.',
          initials: 'BW',
          name: 'Beverly Watts',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "I love the smooth taste and it gives me extra energy and cognition!",
          initials: 'DB',
          name: 'Debra Bergfeld',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Cognition Mushroom ground coffee',
          text: "Super taste.  Mild and smooth. Like it really well.  I have yet to not like any coffee I have ordered",
          initials: 'JR',
          name: 'Jane Rupert',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "I THOROUGHLY ENJOY MY LIFEBOOST COFFEE. I usually purchase just the medium and light roast, but this time I decided to try the Coffee with Mushrooms. I love it! Great products that are non- irritating, less acid. 👍🏽",
          initials: 'DJ',
          name: 'Donna Jenkins',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Great tasting mushroom coffee',
          text: "I was not sure how this coffee was going to taste because I do not like mushrooms, but this is a very good tasting coffee. I am actually ordering another bag.",
          initials: 'SJ',
          name: 'Sandra JohnsonHarrell',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Love it!',
          text: "Can't tell the difference in the taste from my usual medium roast coffee!",
          initials: 'CN',
          name: 'Candace Nunez',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Mushrooms, really?',
          text: "I love mushrooms, but I could not detect a hint of mushrooms at all. Very good medium roast!  And a bonus by helping your brain.",
          initials: 'SM',
          name: 'Susan McFarland',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "Very smooth and great taste",
          initials: 'KS',
          name: 'Kenneth Shaw',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "Great tasting!!",
          initials: 'EB',
          name: 'Emily Bottoms',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Love it',
          text: "Love it, Great taste, no bitterness.",
          initials: 'NB',
          name: 'Nancy Barney',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Blew my Mind!',
          text: "Can't believe how much this really helps synergize with the coffee.  I make my coffee with coconut oil, butter, dash of honey and A2 creamer.  Adding the mushrooms (that you can barely taste by the way) has helped increased the effect of the coffee with no crash and constant energy all day long.  10/10 would reccomend.  Just ordered a 3 pack!  It's now officially a staple.",
          initials: 'T',
          name: 'Tom',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Great Stuff!',
          text: "I was a bit fearful that the mushroom-iness of the coffee would be discernible. It is not. It tastes like great Lifeboost coffee. But it does make me feel sharper.",
          initials: 'TP',
          name: 'Tammy Parker',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Our new favorite',
          text: "We were sceptic about trying but glad we did. Taste great very smooth no taste of Mushroom 😅 we now have it on auto ship.",
          initials: 'NS',
          name: 'Natasha Smith',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'One of the best!!!',
          text: "My morning joy has reached a new level of quality! Excellent!!!",
          initials: 'KT',
          name: 'Kleoniki Tsotropoulou',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "I purchased this new coffee for my husband. He said it is the best coffee and loves the benefits of the mushrooms.",
          initials: 'RP',
          name: 'Renee Patterson',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "I love this product!!!",
          initials: 'AG',
          name: 'Ariel Graf',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Love this version of coffee!',
          text: "Never even heard of it.  After trying it it’s become my second ( or third ) cup of coffee most days.  Different and Delicious!  The health benefits the shrooms add make it even cooler!  Bravo!",
          initials: 'SR',
          name: 'Steven W. Ross',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: '',
          text: "Smooth and tasty",
          initials: 'JH',
          name: 'Janice Hardy Hardy',
          ratingSrc: '/assets/images/rating-yellow.png'
        },
        {
          title: 'Cognition Mushroom coffee is the best!',
          text: "Best coffee option yet!   It is our family's favorite, both for flavor and the way it makes us feel.  Energetic yet calm, no jitters.",
          initials: 'P',
          name: 'Pam ',
          ratingSrc: '/assets/images/rating-yellow.png'
        }

      ]
    }
  ]
});
</script>

<style scoped>
/* Your styles here */
</style>